"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _enUS = _interopRequireDefault(require("./en-US"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var enCA = {
  info: {
    culture: 'Canada',
    language: 'Canadian English',
    languageCultureCode: 'en-CA'
  },
  translations: {
    color: 'colour',
    center: 'centre',
    extras: 'extras',
    measurements: 'measurements',
    installation: 'installation',
    'Free In-Home Consultation': 'Free In-Home Consultation',
    'Selected Color': 'Selected Colour'
  }
};
enCA.translationsByKey = _objectSpread(_objectSpread({}, _enUS["default"].translationsByKey), {}, {
  Pcp: _objectSpread(_objectSpread({}, _enUS["default"].translationsByKey.Pcp), {}, {
    Configuration: _objectSpread(_objectSpread({}, _enUS["default"].translationsByKey.Pcp.Configuration), {}, {
      colorViewingOnly: 'For colour viewing purposes. Mount, cord & tilt options are not shown'
    }),
    ProductInfo: _objectSpread(_objectSpread({}, _enUS["default"].translationsByKey.Pcp.ProductInfo), {}, {
      infoList: _objectSpread(_objectSpread({}, _enUS["default"].translationsByKey.Pcp.ProductInfo.infoList), {}, {
        colorPlaceholder: 'Select a Colour to Preview'
      })
    })
  }),
  Pip: _objectSpread(_objectSpread({}, _enUS["default"].translationsByKey.Pip), {}, {
    ProductGallery: {
      samplesCta: {
        header: 'Colour Sample Swatches',
        description: 'First 10 swatches are free with next day shipping',
        button: {
          small: 'Order',
          normal: 'Order Colour Samples'
        }
      }
    }
  }),
  SamplesCart: _objectSpread({}, _enUS["default"].translationsByKey.SamplesCart)
});
var _default = enCA;
exports["default"] = _default;